import { BaseEntity, JsonApiRelationship, JsonApiResource } from '../jsonapi-provider';
import type Site from './site';

@JsonApiResource({
  type: 'county',
})
export default class County extends BaseEntity {
  name: string = '';
  description: string = '';
  isActive: boolean = false;

  @JsonApiRelationship('site') sites = new Array<Site>();
  constructor(
    id?: County['id'],
    name: County['name'] = '',
    description: County['description'] = '',
    isActive: County['isActive'] = false,
    sites: County['sites'] = new Array<Site>()
  ) {
    super();
    this.id = id;
    this.name = name;
    this.description = description;
    this.isActive = isActive;
    this.sites = sites;
  }
}
